import { slugify } from './slug.utils';

export function getCitySlug(cityName: string): string {
  return slugify(normalizeCityName(cityName));
}

export function normalizeCityName(name: string): string {
  if (!name) return '';
  return name
    .replace(/^Municipiul\s+/i, '')
    .replace(/^Orasul\s+/i, '')
    .replace(/^Oras\s+/i, '')
    .replace(/^Comuna\s+/i, '')
    .replace(/^Sat\s+/i, '')
    .trim();
}
